export default __webpack_public_path__ + "static/media/profile3.386ed919.png";